module.exports = {"id":"229218","name":"Pedro Rocha","rating":"73","photo":"./data/images/photos/1/229218.png","club":{"name":"Spartak Moscou","logo":"./data/images/clubs/SpartakMoscou.png"},"positions":["AG","BU","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PedroRocha0.json
// module id = 3423
// module chunks = 0